export enum CollectionName {
  STRUCTURED_DOCUMENT_COLLECTION = 'Structured Document Collection',
  UNSTRUCTURED_DOCUMENT_COLLECTION = 'Unstructured Document Collection',
  CODING_STANDARDS = 'Coding Standards',
}

export const COLLECTION_NAME_MAPPING = {
  'structured document collection': CollectionName.STRUCTURED_DOCUMENT_COLLECTION
,
  'unstructured document collection': CollectionName.UNSTRUCTURED_DOCUMENT_COLLECTION,
  'coding standards': CollectionName.CODING_STANDARDS
} as const;
